export interface IHorseRacingState {
  isShow: boolean;
  races?: Array<{
    grade: string;
    date: string;
    raceNum: string;
    url: string;
    raceTitle: string;
    status: string;
  }>;
}
const initialState: IHorseRacingState = {
  isShow: false
};
export default (state: IHorseRacingState = initialState) => {
  return state;
};
